
<v-container>
	<v-form ref="locumBankDetailsForm">
		<v-text-field v-model="accountholder" label="Account holder name" outlined></v-text-field>

		<v-text-field v-model="bankname" label="Bank name" outlined></v-text-field>

		<v-text-field v-model="branchcode" label="Branch code" outlined :rules="[numberOnlyRule]"></v-text-field>

		<v-text-field v-model="accountnumber" label="Account number" outlined :rules="[numberOnlyRule]"></v-text-field>

		<v-radio-group v-model="accounttype" row color="orange">
			<v-radio label="Cheque account" value="cheque" color="primary"></v-radio>
			<v-radio label="Savings account" value="savings" color="primary"></v-radio>
		</v-radio-group>

		<v-text-field v-model="sarsnumber" label="SARS registration number" outlined :rules="[numberOnlyRule]"></v-text-field>

		<v-row align="center" justify="center">
			<v-col align="center" justify="center" :cols="7">
				<DistinctYesNo :initial="hasProvisionalTax" :errors="taxPayerYesNoErrors" @input="OnProvisionalTax">Are you a provisional tax payer?</DistinctYesNo>
			</v-col>
		</v-row>

		<v-row>
			<v-col :cols="12" :lg="6">
				<div v-show="hasProvisionalTax == 'yes'">
					<v-file-input
						:label="labelTax"
						:persistent-hint="true"
						:prepend-icon="''"
						prepend-inner-icon="cloud_upload"
						:dense="true"
						outlined
						chips
						show-size
						:error-messages="taxPayerInputError"
						@change="handleProvisionalTaxFile"
					></v-file-input>
					<span v-if="docExists('provisionalTaxFile')">Provisional tax document already uploaded. Click above to upload a new document.</span>
				</div>
			</v-col>
		</v-row>
	</v-form>
	<v-row v-if="solo">
		<v-btn text @click="$refs.locumVerificationForm.reset()">Clear</v-btn>
		<v-spacer></v-spacer>
		<v-btn class="white--text" color="deep-purple accent-4" depressed @click="SubmitForm()">Update</v-btn>
	</v-row>
</v-container>
